$(document).ready(function (){
    let _title = "Nuevo descuento"
    let dir = "add"


    $("#table-individual-discount").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: '/admin/get-individual-discount',
        columns: [
            {data: 'id', name: 'id'},
            {data: 'discount_books.title', name: 'discount_books.title'},
            {data: 'discount', name: 'discount'},
            {data: 'initial_date', name: 'initial_date'},
            {data: 'final_date', name: 'final_date'},
        ],
        "columnDefs": [{
            "targets": 5,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let status = get_global_status(row.status)

                return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn m-1 button_almadia_reverse ' +
                    'individual-discount-edit btn-sm"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></button> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn m-1 btn-' + status.color_clas + ' change-individual-discount-status btn-sm"  ' +
                    'data-id ="' + row.id + '"><i class="' + status.icon + '"></i></button>' +

                    button_individual_discount_delete(row.status,row.id)

            }
        }]
    });
    const list_individual_discounts = $("#table-individual-discount").DataTable()

    $("#add-individual-discount").on('click', function (e){
        e.preventDefault()
        $("#form-individual-discount")[0].reset();
        $(".title-individual-discount").text(_title)
        $("#modal-individual-discount").modal('show')
        $(".item-individual-dir").val(dir)
    })

    $("#table-individual-discount tbody").on('click','.individual-discount-edit',function (e){
        e.preventDefault()
        rowData = list_individual_discounts.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            $(".item-individual-" + index).val(value);
            if (index == "discount_books") {
                $(".item-individual-title-book").val(value.title);
            }
        })

        $(".title-individual-discount").text("Editar descuento")
        $(".item-individual-dir").val("edit")
        $("#modal-individual-discount").modal('show')
    })

    $("#table-individual-discount tbody").on('click','.change-individual-discount-status', function (e){
        e.preventDefault()
        let id = $(this).data('id')
        let data = new FormData()
        data.append('id',id)
        sendData(data,'/admin/change-individual-discount-status')
    })

    $("#table-individual-discount tbody").on('click','.delete-individual_discount', function (e){
        e.preventDefault()
        let id = $(this).data('id')
        let data = new FormData()
        data.append('id',id)
        sendData(data,'/admin/delete-individual-discount')
    })

    $("#form-individual-discount").on('submit',function (e){
        e.preventDefault()
        let data = new FormData(this)
        sendData(data,'/admin/' + $(".item-individual-dir").val() + '-individual-discount')
    })


    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {

                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.success == "success") {
                        $("#modal-individual-discount").modal('hide')
                        $("#table-individual-discount").DataTable().ajax.reload();
                        alertSuccess(response.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function button_individual_discount_delete(status,id) {
        if (status === "D") {
            return button = '<a href="#" data-toggle="tooltip" data-placement="top" title="Eliminar" ' +
                'class="btn btn-danger delete-individual_discount btn-sm m-1"  ' +
                'data-id ="' + id + '"><i class="fa-solid fa-trash-can-arrow-up"></i></a> ' ;
        }
        return "";
    }





})
